import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconGutterHorizontal24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconGutterHorizontal24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M19.25 5.5a.75.75 0 0 0 0-1.5 2.75 2.75 0 0 0-2.75 2.75v10.5A2.75 2.75 0 0 0 19.25 20a.75.75 0 0 0 0-1.5c-.69 0-1.25-.56-1.25-1.25V6.75c0-.69.56-1.25 1.25-1.25M12 6.003a.75.75 0 0 1 .75.75V17.25a.75.75 0 0 1-1.5 0V6.753a.75.75 0 0 1 .75-.75M4 19.25a.75.75 0 0 1 .75-.75c.69 0 1.25-.56 1.25-1.25V6.75c0-.69-.56-1.25-1.25-1.25a.75.75 0 1 1 0-1.5A2.75 2.75 0 0 1 7.5 6.75v10.5A2.75 2.75 0 0 1 4.751 20a.75.75 0 0 1-.75-.75"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconGutterHorizontal24);
